import { createFileRoute } from "@tanstack/react-router";

import { InvitationsContainer } from "@/features/settings/containers/invitations-container";

export const Route = createFileRoute("/app/settings/user/invitations")({
  component: InvitationsContainer,
});
